
































import { Vue, Component } from 'vue-property-decorator';
import { loading } from '@/decorators';
import { VNode } from 'vue';

@Component
export default class OutboundOrderRulesPage extends Vue {
  // 列表数据
  protected dataList: TypeOutboundOrder.RulesListItem[] = [];
  // 表格列
  protected columns: TypeBase.TableColumn[] = [];
  protected loadingStatus: boolean = false;
  // 搜索项
  protected searchData: TypeOutboundOrder.RulesSearchData = this.getInitSearchData();
  protected compareTextMap: TypeBase.ObjectData<string> = {
    1: this.tc('小于等于'),
    2: this.tc('大于等于'),
    3: this.tc('等于'),
  };
  protected getRuleView(data: TypeOutboundOrder.RulesListItem): VNode {
    const h = this.$createElement;
    return (
      <my-operation>
        {data.total_weight_limit_value && data.total_weight_limit_type && (
          <div>
            {this.tc('一个订单的所有商品总重量限制为：{0}', [
              this.compareTextMap[data.total_weight_limit_type] + data.total_weight_limit_value + this.t('KG'),
            ])}
          </div>
        )}
        {data.first_long_side_value && data.first_long_side_limit_type && (
          <div>
            {this.tc('一个订单的任意一个商品最长边限制为：{0}', [
              this.compareTextMap[data.first_long_side_limit_type] + data.first_long_side_value + this.t('CM'),
            ])}
          </div>
        )}
        {data.sku_pieces_value &&  data.sku_pieces_limit_type && (
          <div>{this.tc('一个订单的所有SKU总种类限制为：{0}', [this.compareTextMap[data.sku_pieces_limit_type] + data.sku_pieces_value])}</div>
        )}
        {data.internals_total_value && data.internals_total_limit_type && (
          <div>{this.tc('一个订单的所有商品总数量限制为：{0}', [this.compareTextMap[data.internals_total_limit_type] + data.internals_total_value])}</div>
        )}
        {data.limit_goods_type_list instanceof Array &&
          data.limit_goods_type_list.map((item: string) => {
            return <div>{this.tc('不支持{0}货型对应的商品与其他商品混装', [item])}</div>;
          })}
      </my-operation>
    );
  }
  // 订单规则列表
  @loading('loadingStatus')
  protected async queryLimitRuleList(): Promise<void> {
    const { data } = await this.$api.order.queryLimitRuleList<TypeOutboundOrder.RulesListItem[]>(this.searchData);
    this.dataList = data;
  }
  // 获取初始搜索
  protected getInitSearchData(): TypeOutboundOrder.RulesSearchData {
    return {
      warehouse_code: this.$route.query.warehouseCode as string,
    };
  }
  private created(): void {
    this.columns = [
      {
        title: this.t('规则名称'),
        dataIndex: 'rule_name',
        filterEmpty: true,
      },
      {
        title: this.t('仓库名称'),
        dataIndex: 'warehouse_name',
        filterEmpty: true,
      },
      {
        title: this.t('限制物流产品名称'),
        scopedSlots: {
          customRender: 'sm_code_list',
        },
        filterEmpty: true,
      },
      {
        title: this.t('限制订单类型'),
        dataIndex: 'order_type_text',
        filterEmpty: true,
      },
      {
        title: this.t('限制规则'),
        dataIndex: 'total_weight_limit_value',
        customRender: (value: string | number, row: TypeOutboundOrder.RulesListItem, index: number) => {
          return {
            children: this.getRuleView(row),
          };
        },
      },
      {
        title: this.t('规则更新时间'),
        dataIndex: 'update_time',
        filterEmpty: true,
      },
    ];
    this.queryLimitRuleList();
  }
}
